import { NgModule, 
         Optional, SkipSelf }   from '@angular/core';

import { SharedModule }         from '../shared/shared.module';
import { MenuService }          from './menu/menu.service';
import { PagetitleService }     from './pagetitle/pagetitle.service';
import { TranslatorService }    from './translator/translator.service';
import { ColorsService }        from './colors/colors.service';

import { throwIfAlreadyLoaded } from './module-import-guard';

@NgModule({
    imports: [
      SharedModule
    ],
    declarations: [
    ],
    providers: [
      MenuService,
      PagetitleService,
      TranslatorService,
      ColorsService
    ],
    exports: []
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts